<template>
  <div>
    <div class="flex flex-col md:flex-row md:items-center mb-8">
      <span class="text-2xl md:text-3xl ml-2">Bestellungen</span>
    </div>

    <div class="shadow rounded -mx-4 md:mx-0">
      <div class="p-4 md:p-6 flex justify-between md:justify-start">
        <div class="pl-4 md:mr-6 flex border rounded text-gray-800 overflow-hidden">
          <font-awesome-icon icon="search" class="self-center"></font-awesome-icon>
          <input
            v-model="search"
            type="text"
            placeholder="Suchen"
            class="py-2 px-4 focus:outline-none w-full"
          />
        </div>
      </div>

      <div class="flex flex-col relative">
        <div
          class="
            hidden
            md:flex
            px-6
            py-3
            border-t
            bg-gray-100
            text-gray-600
            font-semibold
            uppercase
          "
        >
          <div class="w-2/6">Bestellung</div>
          <div class="w-2/6">Kaufdatum</div>
          <div class="w-2/6 text-right">Status</div>
        </div>

        <router-link
          :to="{ name: 'order', params: { id: order.id } }"
          v-for="order in orders"
          :key="order.id"
          class="flex py-3 border-t px-4 md:px-6 hover:shadow"
        >
          <div class="w-full md:w-2/6 flex sm:pr-6">
            <div class="w-full min-w-0">
              <div class="flex w-full justify-between">
                <div class="text-gray-800 font-semibold truncate">#{{ order.id }}</div>
              </div>
              <div class="text-sm text-gray-700">{{ order.event.title }}</div>
              <div class="text-sm text-gray-700">{{ order.event.start_date | shortDate }}</div>
            </div>
          </div>

          <div class="w-2/6 self-center hidden md:block">
            <div class="text-gray-700">{{ order.created_at.local | longDate }} Uhr</div>
          </div>

          <div class="w-1/5 md:w-2/6 hidden sm:flex flex-row justify-end">
            <div class="md:w-1/2 self-end justify-end md:self-center flex">
              <div class="self-center">
                <order-status-badge class="px-6" :status="order.status"></order-status-badge>
              </div>
            </div>
          </div>
        </router-link>

        <div v-if="loading" class="spinner"></div>

        <div
          v-if="!orders.length > 0 && !loading"
          class="py-8 text-center flex flex-col justify-center items-center"
        >
          <img src="../assets/images/notasks73.svg" alt="Nothing found" />

          <div class="text-2xl mt-6">Keine Bestellungen gefunden</div>
        </div>
      </div>
    </div>
    <div v-if="orders.length > 0" class="mt-6">
      <button @click="moreOrders" class="btn btn-primary btn-outline">Mehr Laden</button>
    </div>
  </div>
</template>

<script>
import OrderStatusBadge from '@/components/OrderStatusBadge';
import ordersClient from '@/api/merchant/orders';
import dayjs from 'dayjs';

export default {
  props: ['event', 'title'],

  components: {
    OrderStatusBadge,
  },

  filters: {
    shortDate(value) {
      return dayjs(value).format('DD MMM YYYY HH:mm');
    },
    longDate(value) {
      return dayjs(value).format('dddd, DD MMMM YYYY HH:mm');
    },
  },

  data() {
    return {
      orders: [],
      page: 1,
      search: '',
      loading: true,
    };
  },

  watch: {
    search: {
      handler() {
        this.loadOrders();
      },
      immediate: true,
    },
  },

  methods: {
    loadOrders(append = false) {
      this.loading = true;

      if (!append) this.page = 1;

      ordersClient
        .index({ search: this.search, page: this.page })
        .then(({ data }) => {
          append ? this.orders.push(...data.data) : (this.orders = data.data);
        })
        .catch(() => this.$toasted.global.error())
        .then(() => (this.loading = false));
    },
    moreOrders() {
      if (!this.loading) {
        this.page++;
        this.loadOrders(true);
      }
    },
  },
};
</script>
